import { z } from 'zod';
import { CONTEXT_FIELD_IDS, QUESTION_IDS, SESSION_STEPS } from '../../types/ids';
import { scoreValueSchema } from '../../data/schemas';

const questionAnswerSchema = z.object({
  questionId: z.enum(QUESTION_IDS),
  optionId: z.string(),
  score: scoreValueSchema,
  answeredAt: z.string(),
});

/** Lockeres, aber typsicheres Schema für persistierte Sessions (ERR-003/ERR-004). */
export const testSessionSchema = z.object({
  schemaVersion: z.string(),
  scoringVersion: z.string(),
  sessionId: z.string(),
  randomSeed: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  completedAt: z.string().optional(),
  currentStep: z.enum(SESSION_STEPS),
  currentQuestionIndex: z.number().int().min(0).max(13),
  context: z.partialRecord(z.enum(CONTEXT_FIELD_IDS), z.string()),
  answers: z.partialRecord(z.enum(QUESTION_IDS), questionAnswerSchema),
  optionOrders: z.partialRecord(z.enum(QUESTION_IDS), z.array(z.string())),
  result: z.unknown().optional(),
});

export const storedDataSchema = z.object({
  schemaVersion: z.string(),
  session: testSessionSchema.optional(),
  ui: z.object({
    theme: z.enum(['light', 'dark', 'system']),
  }),
});
